var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "interaction-btn",
      class: { "is-complete": _vm.isComplete },
      attrs: {
        type: "button",
        "aria-label": _vm.title,
        disabled: _vm.disabled,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _vm.icon
        ? _c("SvgIcon", {
            staticClass: "interaction-btn__icon",
            attrs: { icon: _vm.icon, "is-filled": _vm.iconFilled },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.title
        ? _c("span", {
            staticClass: "interaction-btn__text",
            domProps: { textContent: _vm._s(_vm.title) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.count
        ? _c("span", {
            staticClass: "interaction-btn__count",
            domProps: { textContent: _vm._s(`+${_vm.count}`) },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }